import { EWeightMeasurementUnit } from "../@types";

export function convertWeight(
	value: number,
	from: EWeightMeasurementUnit,
	to: EWeightMeasurementUnit,
) {
	switch (from) {
		case EWeightMeasurementUnit.KILOGRAM:
			switch (to) {
				case EWeightMeasurementUnit.POUND:
					return value * 2.20462;
				default:
					return value;
			}
		case EWeightMeasurementUnit.POUND:
			switch (to) {
				case EWeightMeasurementUnit.KILOGRAM:
					return value * 0.453592;
				default:
					return value;
			}
		default:
			return value;
	}
}
